import { NgModule } from '@angular/core';
import { OptionModule } from '../../../options/abstract/option.module';
import { RegularCellComponent } from './regular-cell.component';

@NgModule({
  imports: [OptionModule],
  declarations: [RegularCellComponent],
  exports: [RegularCellComponent]
})
export class RegularCellModule {}
